












	// @ts-ignore
    import _ from './CLike.ts'; export default _;
